import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { id: "container" }
const _hoisted_3 = {
  key: 0,
  id: "main-content-port"
}
const _hoisted_4 = { class: "" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "w100 pad20" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header_title fs20 fw600" }, "SSO"),
  /*#__PURE__*/_createElementVNode("div", { class: "fs14 mt20" }, "シングル・サインオン (SAML 2.0) の設定ができます。")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "w100 mt40 mb20" }
const _hoisted_9 = {
  key: 0,
  class: "mt40 pad20"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18 fl",
  style: {}
}, "サービスプロバイダ情報", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = {
  class: "pad10",
  style: {"width":"500px"}
}
const _hoisted_13 = { class: "pad5 mt15" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "fs11 fw600" }, "Audience (SP Entity ID)", -1)
const _hoisted_15 = { class: "fs14 mt2 pad10 borderGrey rad8" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_17 = { class: "pad5 mt15" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "fs11 fw600" }, "ACS URL", -1)
const _hoisted_19 = { class: "fs14 mt2 pad10 borderGrey rad8" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = { class: "pad5 mt15" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "fs11 fw600" }, "ACS URL Validator", -1)
const _hoisted_23 = { class: "fs14 mt2 pad10 borderGrey rad8" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_25 = { class: "pad5 mt15" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "fs11 fw600" }, "Login URL", -1)
const _hoisted_27 = { class: "fs14 mt2 pad10 borderGrey rad8" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_29 = { class: "pad5 mt15" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "fs11 fw600" }, "Single Logout URL", -1)
const _hoisted_31 = { class: "fs14 mt2 pad10 borderGrey rad8" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_33 = { class: "w100 mt40 mb20" }
const _hoisted_34 = {
  key: 0,
  class: "mt40 pad20"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18 fl",
  style: {}
}, "SSO設定", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_37 = {
  key: 1,
  class: "mt40"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", { class: "fl mt5 mr5" }, "シングル・サインオンを有効化", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_40 = {
  key: 2,
  class: "mt40"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", { class: "fl mt5 mr5" }, "全メンバーに対してwaaq Linkのログイン方式をSSOに強制する", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_44 = {
  key: 3,
  class: "fl ml2 w100",
  style: {}
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "w30 fl" }, null, -1)
const _hoisted_46 = {
  key: 0,
  class: "w70 fl",
  style: {}
}
const _hoisted_47 = { class: "mt20" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { class: "fs11 fw600" }, "Identity Provider Issuer (Issuer URL)", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_50 = { class: "mt20" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { class: "fs11 fw600" }, "Identity Provider Single Sign-On URL (SAML 2.0 Endpoint)", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_53 = { class: "mt20" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", { class: "fs11 fw600" }, "SLO Endpoint", -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_56 = { class: "mt20" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { class: "fs11 fw600" }, "X509 公開鍵", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue3_progress_bar = _resolveComponent("vue3-progress-bar")!
  const _component_FlashNotice = _resolveComponent("FlashNotice")!
  const _component_ChukaiSidebarMenu = _resolveComponent("ChukaiSidebarMenu")!
  const _component_AccountHeader = _resolveComponent("AccountHeader")!
  const _component_IconLock = _resolveComponent("IconLock")!
  const _component_Switcher = _resolveComponent("Switcher")!
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!
  const _component_OptionModal = _resolveComponent("OptionModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_vue3_progress_bar),
    _createVNode(_component_FlashNotice),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_ChukaiSidebarMenu, { currentPage: `account` }),
      (_ctx.rm.userInfo)
        ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
            _createElementVNode("section", _hoisted_4, [
              _createVNode(_component_AccountHeader, {
                selectedTab: _ctx.selectedTab,
                ref: "header"
              }, null, 8, ["selectedTab"]),
              _hoisted_5,
              _hoisted_6,
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                (_ctx.canUseOption && _ctx.org.sso_settings.sso_domain)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _hoisted_10,
                      _hoisted_11,
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _hoisted_14,
                          _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.org.sso_settings.sso_sp_entity_id), 1)
                        ]),
                        _hoisted_16,
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.org.sso_settings.sso_sp_acs_url), 1)
                        ]),
                        _hoisted_20,
                        _createElementVNode("div", _hoisted_21, [
                          _hoisted_22,
                          _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.org.sso_settings.sso_sp_acs_url_re), 1)
                        ]),
                        _hoisted_24,
                        _createElementVNode("div", _hoisted_25, [
                          _hoisted_26,
                          _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.org.sso_settings.sso_sp_sign_in_url), 1)
                        ]),
                        _hoisted_28,
                        _createElementVNode("div", _hoisted_29, [
                          _hoisted_30,
                          _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.org.sso_settings.sso_sp_sign_out_url), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_32,
              _createElementVNode("div", _hoisted_33, [
                (_ctx.canUseOption)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _hoisted_35,
                      (!_ctx.canUseOption)
                        ? (_openBlock(), _createBlock(_component_IconLock, {
                            key: 0,
                            style: {"margin-top":"2px"},
                            class: "ml10 fl",
                            width: 16
                          }))
                        : _createCommentVNode("", true),
                      _hoisted_36,
                      (_ctx.org)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            _hoisted_38,
                            _createVNode(_component_Switcher, {
                              value: "type[active]",
                              name: "有効",
                              checked: _ctx.org.sso_settings.can_use_sso,
                              disabled: !_ctx.canUseOption,
                              display: "true",
                              class: "checkUsingCal fl",
                              onSelect: _ctx.changeActive
                            }, null, 8, ["checked", "disabled", "onSelect"]),
                            _hoisted_39
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.canUseOption && _ctx.org.sso_settings.can_use_sso)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            _hoisted_41,
                            _createVNode(_component_Switcher, {
                              value: "type[force]",
                              name: "有効",
                              checked: _ctx.org.sso_settings.is_force_sso_when_sign_in,
                              display: "true",
                              class: "checkUsingCal fl",
                              onSelect: _ctx.changeForceSignIn
                            }, null, 8, ["checked", "onSelect"]),
                            _hoisted_42
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_43,
                      (_ctx.canUseOption && _ctx.org.sso_settings.can_use_sso)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                            _hoisted_45,
                            (_ctx.org)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                  _createElementVNode("div", _hoisted_47, [
                                    _hoisted_48,
                                    _createVNode(_component_TextfieldTag, {
                                      style: {"height":"50px","min-width":"280px","max-width":"100%"},
                                      class: _normalizeClass(`fl fs14 roundForm w100 pageLinkUrl`),
                                      value: _ctx.org.sso_settings.sso_idp_entity_id,
                                      onInputValue: _ctx.inputEntityId,
                                      onClickTextfield: _ctx.clickTextfield
                                    }, null, 8, ["value", "onInputValue", "onClickTextfield"])
                                  ]),
                                  _hoisted_49,
                                  _createElementVNode("div", _hoisted_50, [
                                    _hoisted_51,
                                    _createVNode(_component_TextfieldTag, {
                                      style: {"height":"50px","min-width":"280px","max-width":"100%"},
                                      class: _normalizeClass(`fl fs14 roundForm w100 pageLinkUrl`),
                                      value: _ctx.org.sso_settings.sso_idp_sso_target_url,
                                      onInputValue: _ctx.inputSSOTargetUrl,
                                      onClickTextfield: _ctx.clickTextfield
                                    }, null, 8, ["value", "onInputValue", "onClickTextfield"])
                                  ]),
                                  _hoisted_52,
                                  _createElementVNode("div", _hoisted_53, [
                                    _hoisted_54,
                                    _createVNode(_component_TextfieldTag, {
                                      style: {"height":"50px","min-width":"280px","max-width":"100%"},
                                      class: _normalizeClass(`fl fs14 roundForm w100 pageLinkUrl`),
                                      value: _ctx.org.sso_settings.sso_idp_slo_target_url,
                                      onInputValue: _ctx.inputSLOTargetUrl,
                                      onClickTextfield: _ctx.clickTextfield
                                    }, null, 8, ["value", "onInputValue", "onClickTextfield"])
                                  ]),
                                  _hoisted_55,
                                  _createElementVNode("div", _hoisted_56, [
                                    _hoisted_57,
                                    _createVNode(_component_TextareaTag, {
                                      style: {"min-width":"280px","max-width":"100%","min-height":"280px"},
                                      class: _normalizeClass(`fl fs14 roundForm w100 pageLinkUrl`),
                                      value: _ctx.org.sso_settings.sso_idp_cert,
                                      onInputValue: _ctx.inputIdpCert,
                                      onClickTextfield: _ctx.clickTextfield
                                    }, null, 8, ["value", "onInputValue", "onClickTextfield"])
                                  ]),
                                  _hoisted_58,
                                  (_ctx.canUseOption)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "submit",
                                        class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15 mr20",
                                        style: {"height":"50px"},
                                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
                                      }, " 保存 "))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_59
    ]),
    _createVNode(_component_OptionModal, {
      ref: "OptionModal",
      eventName: _ctx.optionEventName,
      onClickOK: _ctx.clickOK,
      onClickCancel: _ctx.clickCancel
    }, null, 8, ["eventName", "onClickOK", "onClickCancel"])
  ]))
}